import { z } from 'zod'
import { asEnumType } from '@gqloom/zod'

export const themeKeySchema = z
  .enum(['access', 'experience', 'retention', 'hapana_ai'])
  .register(asEnumType, { name: 'ThemeKey' })

export type ThemeKey = z.infer<typeof themeKeySchema>
